<div class="main">
  <div class="top-container">
    <p>Adicionar plano alimentar</p>
    <button (click)="onCancel()">
      <mat-icon class="icon">close</mat-icon>
    </button>
  </div>

  <div class="conteudo">
    <p class="titulo-conteudo">Características do plano*</p>

    <mat-selection-list class="lista-filtros">
      <mat-list-item *ngFor="let item of caracteristicasPlano">
        <mat-checkbox
          [checked]="caracteristicasSelecionadas.includes(item)"
          (change)="onCheckboxChange(item, $event.checked); caracteristicasTocadas = true"
          labelPosition="after"
        >
          {{ item }}
        </mat-checkbox>
      </mat-list-item>
    </mat-selection-list>

    <mat-checkbox
      [checked]="condicoesEspecificasSelecionada"
      (change)="onCondicoesCheckboxChange($event.checked); condicoesEspeciaisTocadas = true"
      labelPosition="after"
    >
      Condições clínicas específicas
    </mat-checkbox>

    <mat-form-field
      appearance="outline"
      *ngIf="condicoesEspecificasSelecionada"
    >
      <mat-label>Condições clínicas específicas*</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="condicoesClinicasEspecificas"
        (ngModelChange)="validarFormulario()"
        (blur)="condicoesEspeciaisTocadas = true; validarFormulario()"
      />
    </mat-form-field>

    <div class="container-datas">
      <mat-form-field appearance="outline">
        <mat-label>Data inicial*</mat-label>
        <input
          matInput
          mask="00/00/0000"
          placeholder="dd/mm/aaaa"
          [(ngModel)]="dataInicial"
          (ngModelChange)="validarFormulario()"
          (blur)="datasTocadas = true; validarFormulario()"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Data final*</mat-label>
        <input
          matInput
          mask="00/00/0000"
          placeholder="dd/mm/aaaa"
          [(ngModel)]="dataFinal"
          (ngModelChange)="validarFormulario()"
          (blur)="datasTocadas = true; validarFormulario()"
        />
      </mat-form-field>
    </div>

    <small style="color: red">{{msgErro}}</small>
  </div>

  <div class="actions">
    <button class="cancelar-btn" (click)="onCancel()">Cancelar</button>
    <button
      mat-raised-button
      [disabled]="!formularioValido"
      class="confirmar-btn"
      (click)="onConfirm()"
    >
      Adicionar
    </button>
  </div>
</div>